// frontend/src/components/games/snake/SnakeControls.tsx

import { Direction } from '../../../hooks/games/useSnakeGame';

interface SnakeControlsProps {
  onDirection: (direction: Direction) => void;
}

export function SnakeControls({ onDirection }: SnakeControlsProps) {
  return (
    <div className="snake-dpad" role="group" aria-label="Yön kontrolleri">
      <button type="button" className="snake-dpad-btn up" onClick={() => onDirection('up')} aria-label="Yukarı">
        ▲
      </button>
      <button type="button" className="snake-dpad-btn left" onClick={() => onDirection('left')} aria-label="Sol">
        ◀
      </button>
      <button type="button" className="snake-dpad-btn right" onClick={() => onDirection('right')} aria-label="Sağ">
        ▶
      </button>
      <button type="button" className="snake-dpad-btn down" onClick={() => onDirection('down')} aria-label="Aşağı">
        ▼
      </button>
    </div>
  );
}
